export default __webpack_public_path__ + "static/tavie-eeebab4f4e23340be4db23caa1b15741.png";